import { observer } from 'mobx-react-lite'
import { Box, IconButton, Typography } from 'shared/ui'
import { TextareaWithLabel } from 'shared/ui/Textarea/TextareaWithLabel/TextareaWithLabel'
import { useTextareaAutoResize } from 'shared/hooks'
import {
  EnhancePrompt,
  type IEnhancePromptProps,
} from 'entities/AIAgent/actions/enhancePrompt/EnhancePrompt'

export type IInstructionsSectionStore = {
  instructions: string
  error: string
  setInstructions: (value: string) => void
  setError: (value: string) => void
  requestEnhance: IEnhancePromptProps['requestEnhance']
}

export type IInstructionsSectionContentProps = {
  store: IInstructionsSectionStore
  isExpanded?: boolean
  onOpenModal?: () => void
}

export const InstructionsSectionContent = observer(
  ({ store, isExpanded, onOpenModal }: IInstructionsSectionContentProps) => {
    const textareaRef = useTextareaAutoResize(
      store.instructions,
      isExpanded ? 452 : 200,
      isExpanded ? 452 : 408
    )

    return (
      <>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          marginBottom={'44px'}
        >
          <Typography
            variant={isExpanded ? 'heading-lg' : 'body-lg-medium'}
            ariaLabel={'Instructions'}
          >
            Instructions
          </Typography>
          <Box display={'flex'} alignItems={'center'} gap={'2px'}>
            <EnhancePrompt
              prompt={store.instructions}
              onAcceptPrompt={store.setInstructions}
              setError={store.setError}
              requestEnhance={store.requestEnhance}
            />
            {!isExpanded && (
              <IconButton
                iconProps={{ fontSize: 16 }}
                variant={'icon'}
                color={'tertiary'}
                size={'small'}
                icon={'solidExpand'}
                ariaLabel='Expand'
                onClick={onOpenModal}
                tooltipProps={{
                  label: 'Expand',
                  placement: 'top',
                }}
              />
            )}
          </Box>
        </Box>
        <TextareaWithLabel
          ref={textareaRef}
          value={store.instructions}
          error={store.error}
          onChange={store.setInstructions}
          placeholder={"Set your agent's role, response style, and add any specific instructions."}
          labelProps={{}}
        />
      </>
    )
  }
)
